import React from 'react';
import DirectoryGroupBody from './components/directory-group-body';

function DirectoryGroup () {
	return (
		<div className="directory-group">
			<DirectoryGroupBody/>
		</div>
	)
}

export default DirectoryGroup;
